var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoCompany(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 85,
    viewBox: "0 0 126 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.68424 74.04V76.4922H2.74652V78.3689H7.71642V80.6459H2.74652V82.5225H8.68424V84.9747H0V74.04H8.68424Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2558 82.5477H20.2196V84.9998H11.5354V74.0652H14.2819V82.5477H14.2558Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2641 74.04V76.4922H24.3264V78.3689H29.2963V80.6459H24.3264V82.5225H30.2902V84.9747H21.5798V74.04H30.2641Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1136 76.4922H51.0853V84.9747H48.3127V76.4922H44.2844V74.04H55.0874L55.1136 76.4922Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9427 78.1437C65.9427 79.7201 65.1318 81.0462 63.9286 81.6718L66.2566 84.9747H62.8561L61.1559 82.2473H59.1679V84.9747H56.4214V74.04H61.9144C64.1901 74.04 65.9427 75.7666 65.9427 78.1437ZM59.1418 76.4922V79.8201H61.4959C62.4376 79.7951 63.1961 79.0194 63.17 78.0936C63.1438 77.2178 62.4114 76.5172 61.5221 76.4922H59.1418Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M79.3614 79.52C79.3614 82.5477 76.798 85.0249 73.6591 84.9998C70.5202 84.9998 67.9568 82.5226 67.9568 79.495C67.9568 76.4673 70.5202 74.0151 73.6591 74.0151C76.798 74.0151 79.3614 76.4923 79.3614 79.52ZM70.3894 79.52C70.3894 81.2465 71.8281 82.6728 73.6068 82.6728C75.4116 82.6728 76.8503 81.2966 76.8765 79.545C76.8765 77.8185 75.4378 76.4173 73.6591 76.3922C71.8542 76.3922 70.3894 77.7935 70.3894 79.52Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M92.3354 84.9998H89.5889L83.8343 78.3189V84.9998H81.0878V74.0652H83.8343L89.5889 80.7461V74.0652H92.3354V84.9998Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M98.4825 84.9998H95.736V74.0652H98.4825V84.9998Z",
    fill: "currentColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M108.265 78.469L113 84.9997H109.442L106.33 80.4707L104.368 82.5225V84.9747H101.621V74.04H104.368V78.8693L108.71 74.04H112.137L108.265 78.469Z",
    fill: "currentColor"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5499 78.469L44.2844 84.9997H40.727L37.6143 80.4707L35.6525 82.5225V84.9747H32.9583V74.04H35.7048V78.8693L40.0469 74.04H43.4735L39.5499 78.469Z",
    fill: "currentColor"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M122.364 83.2732H116.897L116.139 84.9747H113.235L118.1 74.04H121.161L126.026 84.9747H123.097L122.364 83.2732ZM121.396 81.1213L119.618 77.0177L117.813 81.1213H121.396Z",
    fill: "currentColor"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6909 68.7607H35.2863L11.4046 41.1113V68.7607H0V23.5708H11.4046L35.3124 51.1451V23.5708H46.717V68.7607H46.6909Z",
    fill: "currentColor"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8924 68.7606H55.5059V38.8843H69.8924V68.7606Z",
    fill: "currentColor"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M106.225 41.7618L125.948 68.7607H111.169L98.2471 50.0692L90.1121 58.5767V68.7356H78.7075V23.5708H90.1121V43.4383L108.187 23.5708H122.495L106.225 41.7618Z",
    fill: "currentColor"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M85.2992 1.97671C82.5265 -0.675631 77.9751 -0.650609 75.2547 1.97671C72.5082 4.57901 73.8684 12.0856 71.148 14.7129C69.814 15.9891 67.4599 16.6647 64.6349 16.6647H55.5321V30.4518H69.9186V22.0194C69.9186 19.4421 70.6772 16.7898 72.0112 15.5137C74.6531 12.9864 82.5265 14.1875 85.3253 11.5852C88.0718 8.98289 88.0718 4.62905 85.2992 1.97671Z",
    fill: "#E30D13"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCompany);
export default __webpack_public_path__ + "static/media/logo-company.81997a8663a40b29dfa65aede01f3b40.svg";
export { ForwardRef as ReactComponent };